import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseSkipSlide: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-39045-skip-slide')
  },
  skipSlides: (state) => {
    return state.skipSlides
  },
}

export default _getters
